import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Modal, ConfigProvider, theme } from "antd";
import ReactDOM from "react-dom";

import SoundSelector from "./SoundSelector";
import { useState } from "react";

export const ModalSound = ({  
  showModal,
  setShowModal,  
  handleAction,
}) => {
    const [valueSelelected, setValueSelelected] = useState(1)
    

  const handleOk = () => {
    console.log("%c el valor seleccionado es ","color; orange", valueSelelected);
    handleAction(valueSelelected);
    setShowModal(false);
  };
  const handleCancel = () => {
    setShowModal(false);
  };
return ReactDOM.createPortal(
    <>
    <ConfigProvider
        theme={{
            algorithm: theme.darkAlgorithm,
        }}
    >
        <Modal  
            title="Selecciona un sonido" 
            open={showModal} 
            onOk={handleOk} 
            onCancel={handleCancel}
        >
            <SoundSelector valueSelected={valueSelelected} setValueSelected={setValueSelelected} />
        </Modal>
    </ConfigProvider>
    </>,
    document.getElementById("modal")
);
};
